import type { FieldType, FieldProperties, FieldValidations } from "@/types/forms";
import { ShortTextField } from "./ShortTextField";
import { LongTextField } from "./LongTextField";
import { NumberField } from "./NumberField";
import { SliderField } from "./SliderField";
import { RatingField } from "./RatingField";
import { DropdownField } from "./DropdownField";
import { CheckboxField } from "./CheckboxField";
import { YesNoField } from "./YesNoField";
import { EmojiScaleField } from "./EmojiScaleField";
import { DateField } from "./DateField";
import { TimeField } from "./TimeField";
import { DatetimeField } from "./DatetimeField";

export interface FieldRendererProps {
  label: string;
  required?: boolean | null;
  properties: FieldProperties;
  validations: FieldValidations;
  disabled?: boolean;
}

const renderers: Record<FieldType, React.ComponentType<FieldRendererProps>> = {
  short_text: ShortTextField,
  long_text: LongTextField,
  rich_text: LongTextField, // fallback to long_text for preview
  number: NumberField,
  slider: SliderField,
  rating: RatingField,
  dropdown: DropdownField,
  checkbox: CheckboxField,
  yes_no: YesNoField,
  emoji_scale: EmojiScaleField,
  date: DateField,
  time: TimeField,
  datetime: DatetimeField,
};

export function getFieldRenderer(type: FieldType) {
  return renderers[type] ?? ShortTextField;
}

export function parseFieldProperties(json: string | null): FieldProperties {
  if (!json) return {};
  try {
    return JSON.parse(json);
  } catch {
    return {};
  }
}

export function parseFieldValidations(json: string | null): FieldValidations {
  if (!json) return {};
  try {
    return JSON.parse(json);
  } catch {
    return {};
  }
}
